import { RoutesT } from '@/routes/Routes.types';
import {
    LazyAuthPage,
    LazyAuthTgPage,
    LazyRegistrationPage,
    LazyRootPage,
    LazyRecoveryPasswordPage,
    AuthYandexPage,
} from '@/pages';

export const publicRoutes: RoutesT = {
    root: {
        path: '/',
        label: 'Цифровой гардероб',
        element: <LazyRootPage />,
        title: 'Ваш цифровой гардероб',
        description:
            'Цифровой гардероб в смартфоне — ваш логин в fashion-систему',
        hideHeader: true,
    },
    auth: {
        path: '/auth',
        label: 'Аутентификация',
        element: <LazyAuthPage />,
        title: 'Авторизация в WID',
        description:
            'Авторизуйтесь в цифровом гардеробе WID, чтобы создавать образы, планировать события и собирать чемоданы.',
        hideHeader: true,
        subRoutes: {
            authTg: {
                path: '/auth/tg',
                label: 'Аутентификация',
                element: <LazyAuthTgPage />,
                title: 'Вход в WID через Telegram',
                description:
                    'Войдите в цифровой гардероб WID, чтобы создавать образы, планировать события и собирать чемодан. Быстрая авторизация через Telegram Mini App.',
                hideHeader: true,
            },
            authYandex: {
                path: '/auth/yandex',
                label: '',
                element: <AuthYandexPage />,
                title: 'Вход в WID через Yandex',
                description:
                    'Войдите в цифровой гардероб WID, чтобы создавать образы, планировать события и собирать чемодан. Быстрая авторизация через Yandex-аккаунт.',
                hideHeader: true,
            },
        },
    },
    registration: {
        path: '/registration',
        label: 'Регистрация',
        element: <LazyRegistrationPage />,
        title: 'Регистрация в WID',
        description:
            'Зарегистируйтесь в цифровом гардеробе WID, чтобы создавать образы, планировать события и собирать чемоданы.',
        hideHeader: true,
    },
    recoveryPassword: {
        path: '/recovery-password',
        label: 'Восстановление пароля',
        element: <LazyRecoveryPasswordPage />,
        title: 'Восстановление пароля',
        description: 'Здесь вы сможете восстановить свой пароль',
        hideHeader: true,
    },
};
